<template>
  <button
    :class="{ 'isActive': isActive }"
    class="actionfilter btn d-inline-flex grid--va-center"
  >
    <span
      data-grid
      class="actionfilter__quantity grid--va-center grid--center"
    >
      {{ quantity }}
    </span>

    {{ label }}
  </button>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FilteringButton',

  props: {
    label: {
      type: String,
      required: true
    },

    quantity: {
      type: Number || String,
      required: true
    },

    isActive: {
      type: Boolean
    }
  }
})
</script>

<style lang="scss" scoped>
  .actionfilter {
    $this: &;

    margin-block: 10px;

    border-radius: 50px;
    padding: 6px 8px 6px 6px;
    background-color: var(--transparent);

    font: normal 600 1.4rem / 1.375 "Nunito", sans-serif;

    &.isActive {
      color: rgb(var(--gray1));
      background-color: rgb(var(--white));

      #{$this}__quantity {
        color: rgb(var(--white));
        background-color: var(--primary);
      }
    }

    &__quantity {
      width: 25px;
      height: 25px;
      margin-inline: 0 12px;
      border-radius: inherit;
      background-color: rgb(var(--white));

      color: var(--primary);
      font: normal 700 1.4rem / 1.3571 "Nunito", sans-serif;
    }

    @media (min-width: 1024px) {
      & + .actionfilter {
        margin-inline: 29px 0;
      }
    }
  }
</style>
